import {
  makeStyles,
  CircularProgress,
  CircularProgressProps
} from "@material-ui/core";

const useStyles = makeStyles(theme => ({
  wrapper: {
    marginTop: theme.spacing(3),
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  message: {
    textAlign: "center"
  }
}));

export default function LoadingIndicator({
  size = 100,
  message = null,
  progress = 0
}: {
  size?: number;
  message?: null | string | JSX.Element;

  /** If we know the progress of what we're loading, specify this (between 0 and 1) */
  progress?: number;
}): JSX.Element {
  const classes = useStyles();
  const progressProps: CircularProgressProps = { size, thickness: 1 };
  if (progress) {
    progressProps.variant = "determinate";
    progressProps.value = progress * 100;
  }

  return (
    <div className={classes.wrapper}>
      <CircularProgress {...progressProps} />
      {message ? <p className={classes.message}>{message}</p> : null}
    </div>
  );
}
